<div class="trusted-provider-issuers-container">
    <mat-accordion>
        <ac-expansion-panel [classes]="'contact-container operator-connect-expansion-panel ' + (cardHasError ? 'cardHasError' : '')"
                            [expanded]="true"
                            [headerTemplate]="headerTemplate"
                            [descriptionTemplate]="removeButtonTemplate"
                            [descriptionObject]="{index: index, type: 'trustedProviderIssuers'}">

            <ac-input-container label="Provider Issuer">
                <ac-textfield [acModel]="parentObject.trustedProviderIssuers[index]"
                              (acModelChange)="parentObject.trustedProviderIssuers[index] = $event"
                              [attr.alternativeName]="'tenant.operatorConnectInfo.trustedProviderIssuers.' + index"
                              [textFieldId]="'tenant-operatorConnectInfo-trustedProviderIssuers' + index">
                </ac-textfield>
            </ac-input-container>

        </ac-expansion-panel>

        <ng-template #headerTemplate>
            <div class="oc-panel-header">
                {{'Trusted Provider Issuer ' + (index + 1)}}
            </div>
        </ng-template>
    </mat-accordion>
</div>

